import { render, staticRenderFns } from "./SummaryBrand.vue?vue&type=template&id=0a9f0249"
import script from "./SummaryBrand.vue?vue&type=script&lang=js"
export * from "./SummaryBrand.vue?vue&type=script&lang=js"
import style0 from "./SummaryBrand.vue?vue&type=style&index=0&id=0a9f0249&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports